import { useState } from "react";
import { Plus, X } from "lucide-react";
import Button from "./Button";

export default function EditableList({ label, hint, items = [], onChange, placeholder = "Add new option" }) {
  const [draft, setDraft] = useState("");

  const add = () => {
    const v = draft.trim();
    if (!v) return;
    if (items.includes(v)) return;
    onChange([...items, v]);
    setDraft("");
  };

  const remove = (idx) => {
    const next = items.filter((_, i) => i !== idx);
    onChange(next);
  };

  return (
    <div>
      {label && <div className="text-xs font-medium text-brand-slate mb-1.5">{label}</div>}
      {hint && <div className="text-xs text-brand-slate mb-2">{hint}</div>}
      <div className="flex flex-wrap gap-1.5 mb-2 min-h-[28px]">
        {items.length === 0 && <span className="text-xs text-brand-slate italic">No items yet.</span>}
        {items.map((item, idx) => (
          <span
            key={`${item}-${idx}`}
            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-brand-blue-soft text-brand-blue-dark border border-blue-200"
          >
            {item}
            <button
              type="button"
              onClick={() => remove(idx)}
              className="hover:text-red-600 transition-colors"
              aria-label={`Remove ${item}`}
            >
              <X size={12} />
            </button>
          </span>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          type="text"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())}
          placeholder={placeholder}
          className="flex-1 px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-brand-blue/30 focus:border-brand-blue dark:bg-[var(--bg-soft)] dark:border-[var(--border-soft)] dark:text-[var(--text-primary)]"
        />
        <Button type="button" variant="secondary" onClick={add}><Plus size={14} /> Add</Button>
      </div>
    </div>
  );
}
